const technologyList = [{
        img: "/static/img/core/yuanjulihongmoshibie.png",
        imgname: "yuanjulihongmoshibie",
        reveal: "/static/img/core/yuanjulihongmoshibie_r.jpg",
        title: "Remote iris recognition",
        desc: [
            "Iristar is committed to tackling the key problems of iris recognition technology in unrestricted scenes, breaking through the limitations of traditional products such as short recognition distance, high environmental requirements and poor user experience, and realizing the second level iris information collection and identity recognition of users in the movement of 1 meter away",
            "The new long-distance iris recognition product supports cross region and cross scene information sharing and centralized control, which provides a strong guarantee for accurate and efficient identity information management of 100 million people in complex scenes.",
        ],
    },
    {
        img: "/static/img/core/hongmorenlianrongheshibie.png",
        imgname: "hongmorenlianrongheshibie",
        reveal: "/static/img/core/hongmorenlianrongheshibie_r.jpg",
        title: "Iris face fusion recognition",
        desc: [
            "Iristar technology is the first to create a new generation of facial multimodal biometric recognition technology, which integrates the high precision of iris and the high ease of use of face, realizing double precision guarantee, double live detection, double anti-counterfeiting authentication and second level recognition response.",
            "Iris face fusion recognition products can combine ID card, passport, all-in-one card and other corresponding documents to collect iris information while comparing the ID cards,",
            "And then realize the unlicensed passage based on high-precision facial multimodal biometric recognition, which greatly liberates manpower and improves regional security.",
        ],
    },
    {
        img: "/static/img/core/jisuanchengxiang.png",
        imgname: "jisuanchengxiang",
        reveal: "/static/img/core/jisuanchengxiang_r.jpg",
        title: "Computational imaging",
        desc: [
            "Iristar's self-designed microlens array light field camera combines imaging and computing, overcomes the bottleneck of traditional photoelectric imaging, and significantly expands the imaging depth of field;",
            "At the same time, rich two-dimensional color and three-dimensional depth signals are captured to realize the integrated acquisition of multi-dimensional photoelectric information.",
            "Computational imaging technology provides high-dimensional image data source for depth estimation, three-dimensional measurement and feature analysis, which can be widely used in biometric recognition, human-computer interaction, industrial vision and other fields.",
        ],
    },
    {
        img: "/static/img/core/guanjiandianjiance.png",
        imgname: "guanjiandianjiance",
        reveal: "/static/img/core/关键点检测_r.jpg",
        title: "Key point detection",
        desc: [
            "Iristar face key point detection can accurately locate and follow the key parts of the face, and make clear the face contour, eyebrow, eye, nose, mouth and other key parts.",
            "It can detect accurately even under the condition of head down and side face, providing the basis for more extensive applications.",
        ],
    },
    {
        img: "/static/img/core/huotijiance.png",
        imgname: "huotijiance",
        reveal: "/static/img/core/活体检测_r.png",
        title: "In vivo detection",
        desc: [
            "Four kinds of live detection services are provided to judge whether the user in the recognition scene is a 'real person', effectively resist different types of attacks such as photos and videos, and ensure the security of the recognition system.",
        ],
    },
    {
        img: "/static/img/core/shuxingfenxi.png",
        imgname: "shuxingfenxi",
        reveal: "/static/img/core/属性分析_r.jpg",
        title: "Attribute analysis",
        desc: [
            "Based on lightweight deep learning model, Rainbow Star attribute analysis SDK can analyze image or video stream in real time, including age, race, gender, expression, posture, occlusion, heart rate and other attributes.",
        ],
    },
    {
        img: "/static/img/core/rentizitai.png",
        imgname: "rentizitai",
        reveal: "/static/img/core/rentizitai_r.jpg",
        title: "Body posture",
        desc: [
            "Based on the deep learning human recognition scheme, human key point technology can detect the human body in the image and return to the position of human rectangular frame,",
            "Accurate positioning includes 14 core key points, including head, neck, shoulder, elbow, hand, hip, knee and foot. Support multi person detection, big action recognition and other complex scene applications.",
        ],
    },
    {
        img: "/static/img/core/toubuzitai.png",
        imgname: "toubuzitai",
        reveal: "/static/img/core/头部姿态_r.jpg",
        title: "Head posture",
        desc: [
            "Iristar head attitude estimation, real-time positioning of the head's pitch angle, roll angle and yaw angle, continuous and natural between video frames,",
            "Even in the complex environment of large attitude and dark light, it can detect accurately, which provides good technical support for other technology research and development",
        ],
    },
    {
        img: "/static/img/core/shixianzhuizong.png",
        imgname: "shixianzhuizong",
        reveal: "/static/img/core/视线跟踪_r.jpg",
        title: "Eye tracking",
        desc: [
            "Eye tracking technology is helpful to determine the fixation position on the digital screen, feedback blink frequency and pupil response to different stimuli.",
            "Therefore, it helps to determine the direction of a person's vision, whether he is sleepy, judge his focus, etc.",
            "The technology has a wide application prospect in the field of human-computer interaction in smart phones, AR / VR games, intelligent cars and other fields.",
            "Iristar's line of sight tracking technology can accurately detect the movement of human eye line of sight. It is simple and natural to operate, and can interact without the user's perception. The speed of operation interaction can be synchronized with the user's viewing speed in real time.",
        ],
    },
    {
        img: "/static/img/core/ORC.png",
        imgname: "ORC",
        reveal: "/static/img/core/OCR_r.jpg",
        title: "OCR",
        desc: [
            "Relying on artificial intelligence technology such as deep learning, OCR character detection and recognition are realized.",
            "It can be used for image text, certificate text, industrial field recognition, etc., to meet the OCR needs of a variety of scenes, and facilitate users to extract or enter text.",
            "Character recognition accuracy 99.67%",
        ],
    },
    {
        img: "/static/img/core/ISP.png",
        imgname: "ISP",
        reveal: "/static/img/core/ISP_r.png",
        title: "ISP",
        desc: [
            "Organic integration of automatic exposure, automatic focusing,",
            " automatic white balance, denoising, sharpening and other processing modules,",
        ],
    },

    {
        img: "/static/img/core/PCB.png",
        imgname: "PCB",
        reveal: "/static/img/core/PCB_r.jpg",
        title: "PCB",
        desc: [
            "The second level alignment method of 50 million pixel image can not only adapt to the linear displacement change, but also achieve good results when the local area changes nonlinearly.",
        ],
    },

    {
        img: "/static/img/core/.png",
        imgname: "xingweifenxi",
        reveal: "/static/img/core/xingweifenxi_r.jpg",
        title: "Behavior analysis",
        desc: [
            "Accurate and real-time recognition of human head, shoulder, knee, ankle and other 14 key bone points;",
            "It has strong robustness to complex background, illumination change, large area occlusion, clothing change and exaggerated posture;",
            "It supports different levels of accuracy and speed, and is competent for different levels of detection tasks from single image to video.",
        ],
    },



    {
        img: "/static/img/core/jiancefenge.png",
        imgname: "jiancefenge",
        reveal: "/static/img/core/检测分割_r.png",
        title: "Detection segmentation",
        desc: [
            "The international first deep learning iris segmentation algorithm achieves high precision and low quality iris image segmentation, expands the scope of iris application, and won the best paper award at the International Biometric Recognition conference",
        ],
    },

    {
        img: "/static/img/core/sanweichangjing.png",
        imgname: "sanweichangjing",
        reveal: "/static/img/core/sanweichangjing_r.png",
        title: "3D scene",
        desc: [
            "Combined with depth camera and RGB camera, high-precision 3D modeling of the scene is carried out to understand the spatial relationship of objects in the scene, and provide basic data support for robot obstacle avoidance, human-computer interaction, VR / AR and other applications.",
        ],
    },
    {
        img: "/static/img/core/sanweizitaifenxi.png",
        imgname: "sanweizitaifenxi",
        // reveal: "/static/img/core/sanweizitaifenxi_r.jpg",
        title: "3D pose analysis",
        desc: [
            "By synthesizing the pose estimation results of multiple 2D cameras, the position of human body in 3D space can be estimated, and the real-time 3D pose estimation can be realized, even in the scene of multiple people.",
        ],
    },
    {
        img: "/static/img/core/shipinyuyi.png",
        imgname: "shipinyuyi",
        // reveal: "/static/img/core/视频语义_r.png",
        title: "Video semantics",
        desc: [
            "Based on single frame image analysis and temporal action analysis, the relationship among people, objects and scenes in the video is automatically understood, the key information is extracted, and the text summary of the video is generated.",
        ],
    },



    {
        img: "/static/img/core/wenbenkexindu.png",
        imgname: "wenbenkexindu",
        // reveal: "/static/img/core/文本可信度_r.png",
        title: "Text credibility",
        desc: [
            "The candidate information of credible information is extracted by word structure features, and the credibility analysis and judgment of information source are added to the credibility calculation of candidate information to improve the accuracy of information credibility evaluation.",
        ],
    },
    {
        img: "/static/img/core/wenbenyuyi.png",
        imgname: "wenbenyuyi",
        // reveal: "/static/img/core/wenbenyuyi_r.jpg",
        title: "Text semantics",
        desc: [
            "Through a series of AI algorithms of rainbow star, the text is parsed into structured, machine-readable intention and slot information, so as to better understand and meet the needs of users.",
        ],
    },
    {
        img: "/static/img/core/yonghuhuaxiang.png",
        imgname: "yonghuhuaxiang",
        // reveal: "/static/img/core/yonghuhuaxiang_r.jpg",
        title: "User portrait",
        desc: [
            "Multimodal deep learning is used to fuse historical behavior and personal information to form accurate user portraits and tags.",
        ],
    },

];

export default technologyList;